import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import { FaDownload } from 'react-icons/fa';
import resumePDF from '../assets/Adarsh_Updated_Resume.pdf'; // Updated to new resume
import profileImg from '../assets/ADARSH.jpg'; // ✅ Your profile picture
import '../App.css';

export default function Home() {
  return (
    <div className="text-center">
      <div className="mb-4 d-inline-block px-3 py-1 rounded-pill border border-secondary small text-dim">
        Software Engineer | Java & MERN Developer
      </div>

      <div className="mb-5">
        <img
          src={profileImg}
          alt="Adarsh Mishra"
          className="profile-img"
        />
      </div>

      <h1 className="display-2 fw-bolder mb-3 text-main">
        I'm <span className="text-accent">Adarsh Mishra</span>
      </h1>

      <h2 className="typing-text mb-5 fs-4 text-dim">
        <TypeAnimation
          sequence={[
            'Full Stack Web Development',
            2000,
            'Java & Spring Boot Engineering',
            2000,
            'MERN Stack Development',
            2000,
            'Cloud & DevOps Enthusiast',
            2000,
          ]}
          wrapper="span"
          speed={50}
          repeat={Infinity}
        />
      </h2>

      <div className="d-flex gap-3 justify-content-center">
        <a
          href={resumePDF}
          download="Adarsh_Kumar_Mishra_Resume.pdf"
          className="btn-glow"
        >
          <FaDownload className="me-2" />
          Download Resume
        </a>
      </div>
    </div>
  );
}
